module.exports = __webpack_public_path__ + "static/03-calendar 1-1b6c29d6d27efa74466f2b763ea0a8aa.svg";